import type { App, Plugin } from 'vue'
import { humanize, capitalize, truncate, toLowerCase } from '@utils/formats'
import { getFullAvatarURL } from '@utils/getters'
import {
  getSanitizedComponentName,
  getSanitizedComponentFieldName,
} from '@utils/specifics'

const installFilters: Plugin = {
  install(app: App): void {
    app.config.globalProperties.$filters = {
      fullAvatarURL: getFullAvatarURL,
      sanitizeComponentName: getSanitizedComponentName,
      sanitizeComponentFieldName: getSanitizedComponentFieldName,
      humanize,
      capitalize,
      truncate,
      toLowerCase,
    }
  },
}

export default installFilters
